<template>
  <div class="no-overflow-modal">
    <div class="b-r">
      <form @submit.prevent="submitBug">
      <!-- קישור לעמוד הרלוונטי -->
      <div class="field">
        <label class="label">קישור לעמוד הרלוונטי (לא חובה)</label>
        <div class="control">
          <input
            v-model="formData.pageUrl"
            class="input"
            type="url"
            placeholder="https://admin.example.com/positions/123"
          />
        </div>
      </div>

      <!-- על מה לחצת -->
      <div class="field">
        <label class="label">על מה לחצת? *</label>
        <div class="control">
          <textarea
            v-model="formData.clickedOn"
            class="textarea"
            placeholder="תאר בפירוט על איזה כפתור/קישור/אלמנט לחצת..."
            rows="3"
            required
          ></textarea>
        </div>
      </div>

      <!-- מה ציפית שיקרה -->
      <div class="field">
        <label class="label">מה ציפית שיקרה? *</label>
        <div class="control">
          <textarea
            v-model="formData.expectedBehavior"
            class="textarea"
            placeholder="תאר מה היה אמור לקרות לפי דעתך..."
            rows="3"
            required
          ></textarea>
        </div>
      </div>

      <!-- מה קרה בפועל -->
      <div class="field">
        <label class="label">מה קרה בפועל? *</label>
        <div class="control">
          <textarea
            v-model="formData.actualBehavior"
            class="textarea"
            placeholder="תאר מה קרה בפועל, כולל הודעות שגיאה אם היו..."
            rows="3"
            required
          ></textarea>
        </div>
      </div>

      <!-- סביבה -->
      <div class="field">
        <label class="label">באיזה סביבה? *</label>
        <div class="control">
          <div class="columns">
            <div class="column" v-for="env in environments" :key="env.value">
              <label class="checkbox">
                <input
                  type="checkbox"
                  :value="env.value"
                  v-model="formData.environment"
                />
                {{ env.label }}
              </label>
            </div>
          </div>
        </div>
        <p v-if="environmentError" class="help is-danger">נא לבחור לפחות סביבה אחת</p>
      </div>

      <!-- מספר סידורי -->
      <div class="field">
        <label class="label">מספר סידורי רלוונטי (מועמד/משרה)</label>
        <div class="control">
          <input
            v-model="formData.serialNumber"
            class="input"
            type="text"
            placeholder="למשל: 7550, 3421..."
          />
        </div>
      </div>

      <!-- צילום מסך -->
      <div class="field">
        <label class="label">צילום מסך</label>
        <div class="control">
          <ImageUploadArea
            :current-image="formData.screenshot"
            :disabled="loading"
            @image-select="handleImageSelect"
          />
        </div>
      </div>

      <!-- מי מדווח -->
      <div class="field">
        <label class="label">מי מדווח?</label>
        <div class="control">
          <input
            v-model="formData.reportedBy"
            class="input"
            type="text"
            placeholder="שם המדווח..."
          />
        </div>
      </div>

      <!-- חשיבות -->
      <div class="field">
        <label class="label">רמת חשיבות (1-100)</label>
        <div class="control">
          <input
            v-model="formData.priority"
            class="input"
            type="range"
            min="1"
            max="100"
          />
        </div>
        <div class="has-text-centered">
          <span class="tag is-info">{{ formData.priority }}</span>
        </div>
        <div class="is-flex is-justify-content-space-between">
          <span class="is-size-7">נמוכה (1)</span>
          <span class="is-size-7">גבוהה (100)</span>
        </div>
      </div>

      <!-- Submit buttons -->
      <div class="field is-grouped is-grouped-right mt-5">
        <div class="control">
          <button
            @click="submitBug"
            type="button"
            class="button is-danger"
            :class="{ 'is-loading': loading }"
            :disabled="loading"
          >
            דווח על באג
          </button>
        </div>
        <div class="control">
          <button @click="closeModal" type="button" class="button" :disabled="loading">
            ביטול
          </button>
        </div>
      </div>
      </form>
    </div>
  </div>
</template>

<script>
import ImageUploadArea from './ImageUploadArea.vue'

export default {
  name: 'BugReportModal',
  components: {
    ImageUploadArea
  },
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      environmentError: false,
      formData: {
        pageUrl: '',
        clickedOn: '',
        expectedBehavior: '',
        actualBehavior: '',
        environment: [],
        serialNumber: '',
        screenshot: null,
        reportedBy: this.$utils.getOwner().full_name || 'אדמין',
        priority: 50
      },
      environments: [
        { value: 'ריבייס', label: 'ריבייס' },
        { value: 'סוטאפ', label: 'סוטאפ' },
        { value: 'פיולה', label: 'פיולה' },
        { value: 'כולם', label: 'כולם' }
      ]
    }
  },
  methods: {
    closeModal () {
      if (this.payload && this.payload.onClose) {
        this.payload.onClose()
      }
    },
    handleImageSelect (file) {
      this.formData.screenshot = file
    },
    async submitBug () {
      // Validation
      if (!this.formData.clickedOn.trim()) {
        this.$utils.emit('show_toast', { text: 'נא למלא על מה לחצת', type: 'error' })
        return
      }

      if (!this.formData.expectedBehavior.trim()) {
        this.$utils.emit('show_toast', { text: 'נא למלא מה ציפית שיקרה', type: 'error' })
        return
      }

      if (!this.formData.actualBehavior.trim()) {
        this.$utils.emit('show_toast', { text: 'נא למלא מה קרה בפועל', type: 'error' })
        return
      }

      if (this.formData.environment.length === 0) {
        this.environmentError = true
        this.$utils.emit('show_toast', { text: 'נא לבחור לפחות סביבה אחת', type: 'error' })
        return
      }

      this.environmentError = false
      this.loading = true

      try {
        // Build the enhanced clickedOn content
        let enhancedClickedOn = 'סביבת עבודה: ממשק הניהול'

        if (this.formData.pageUrl && this.formData.pageUrl.trim()) {
          enhancedClickedOn += '\nקישור לעמוד: ' + this.formData.pageUrl.trim()
        }

        enhancedClickedOn += '\n' + this.formData.clickedOn.trim()

        // Create enhanced form data
        const enhancedFormData = {
          ...this.formData,
          clickedOn: enhancedClickedOn
        }

        const response = await this.$network_utils.reportBug(enhancedFormData)

        if (response.success) {
          this.$utils.emit('show_toast', { text: 'הבאג דווח בהצלחה', type: 'success' })
          this.closeModal()
        } else {
          throw new Error(response.error || 'שגיאה בדיווח הבאג')
        }
      } catch (error) {
        console.error('Error reporting bug:', error)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בדיווח הבאג: ' + (error.message || 'שגיאה לא ידועה'),
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.checkbox input {
  margin-left: 0.5rem;
}

.textarea, .input {
  direction: rtl;
  text-align: right;
}

.label {
  text-align: right;
}

.help {
  text-align: right;
}

.no-overflow-modal {
  overflow: hidden !important;
  height: 70vh;
}

.b-r {
  height: 65vh;
  overflow-y: auto;
  padding: 20px;
}
</style>
